import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { postRequest as post } from '../utils/HttpMethods';
import { useNotification } from '@refinedev/core';

interface GenerateBlueCrossPDFResponse {
  url: string;
}

const generateBlueCrossPDF = async ({
  claimID,
}: {
  claimID: string;
}): Promise<GenerateBlueCrossPDFResponse> => {
  try {
    const pdf: GenerateBlueCrossPDFResponse = await post(
      'QBilling',
      '/action/generate/bluecross',
      {
        claimID,
      }
    );

    return { url: pdf?.url };
  } catch (error) {
    throw new Error('Failed to generate Blue Cross PDF');
  }
};

export const useGenerateBlueCrossPDF =
  (): UseMutationResult<GenerateBlueCrossPDFResponse> => {
    const { open } = useNotification();
    return useMutation({
      mutationFn: generateBlueCrossPDF,
      onError: (error) => {
        open({
          message: 'Error generating Blue Cross PDF',
          description: error.message,
          type: 'error',
        });
      },
      onSuccess: () => {
        open({
          message: 'Blue Cross PDF Generated',
          description: 'Blue Cross PDF file has been generated successfully.',
          type: 'success',
        });
      },
    });
  };
